export enum SettingsTextElement {
  Contact = 'here',
  Target = '_blank',
}
